//--------------- EXPORT DO UTILITÁRIO FORMATTER DATE AND TIME ---------------//
export default function formatterDateAndTime(timestamp) {
  if (!timestamp) return '-';

  const data = new Date(timestamp);

  if (isNaN(data)) return 'Data inválida';

  return data.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}